import { FileInfo } from '../../../types';

export type OperationType =
  | 'file.upload'
  | 'file.delete'
  | 'file.update'
  | 'file.download'
  | 'file.share'
  | 'file.move'
  | 'folder.put'
  | 'folder.delete'
  | 'folder.move'
  | 'folder.copy'
  | 'folder.update'
  | 'password.put'
  | 'password.update'
  | 'password.delete'
  | 'share.delete'
  | 'share.update'
  | 'share.share'
  | 'inbox.delete'
  | 'inbox.update'
  | 'inbox.download'
  | '*.update'
  | '*.delete'
  | '*.share'
  | '*.move'
  | '*.put'
  | '*.download';
export interface DeclareRequestSpec {
  operationType: OperationType;
  pathName?: string;
  encriptionIV?: string;
  encriptionDEK?: string;
  contentMD5?: string;
  contentLength?: number;
  content?: {
    info?: any; // Cambiato da string a any
    encrypted_content?: string;
    file?: File | FileInfo;
    isEncryptedZone?: boolean;
  };
  proof?: string;
  mimeType?: string;
}

export interface OperationSpec {
  operationId: string;
  type: OperationType;
  from?: string;
  to?: string;
  canAbort: boolean;
  iv?: string;
  enc_dek?: string;
  md5?: string;
  encrypted_content?: string;
  info?: any;
  file?: File | FileInfo;
  isEncryptedZone?: boolean;
  path?: string;
  proof?: string;
  silent?: boolean;
}

export class OperationContext {
  declareRequestSpec?: DeclareRequestSpec;
}
